import axios from "axios";

export const COURSE_URL = "/Course";
export const GRADE_COURSE_URL = "/GradeCourse";

/** Belli Bir Sınıf Ders Listesini Elde Eder */
export function getGradeCourses(queryParams) {
  return axios.post(`${GRADE_COURSE_URL}/GetGradeCourses`, queryParams);
}

/** Belli Bir Sınıf Ders Listesini Sayfalama Olmadan Elde Eder */
export function getAllGradeCourses(queryParams) {
  return axios.post(`${GRADE_COURSE_URL}/GetAllGradeCourses`, queryParams);
}

/** Mevcut Okulun Aktif Ders Listesini Elde Eder */
export function getCourses() {
  return axios.get(`${COURSE_URL}/GetCourses`);
}

/** Yeni Bir Sınıf Dersi Elde Eder */
export function getNewCourse() {
  return axios.get(GRADE_COURSE_URL);
}

/** Belli Bir Sınıf Dersini Elde Eder */
export function getCourse(id) {
  return axios.get(`${GRADE_COURSE_URL}/${id}`);
}

/** Belli Bir Sınıf Dersini Kaydeder */
export function saveCourse(course) {
  return axios.post(GRADE_COURSE_URL, course);
}

/** Belli Bir Sınıf Ders Listesini Siler */
export function deleteCourses(ids) {
  return axios.post(`${GRADE_COURSE_URL}/Delete`, ids);
}